import { render, staticRenderFns } from "./DispatchStatisticsReports.vue?vue&type=template&id=2cf8e932&scoped=true"
import script from "./DispatchStatisticsReports.vue?vue&type=script&lang=js"
export * from "./DispatchStatisticsReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf8e932",
  null
  
)

export default component.exports